import { Component, Input, OnInit, AfterViewInit, EventEmitter, Output, OnDestroy } from "@angular/core";
import { Form, UntypedFormBuilder, FormGroup, Validators } from "@angular/forms";
import { DataProvider } from "projects/packcert-web/src/app/providers/data.provider";
import { Message, SpinnerService } from 'shared-components';
import { Subject, BehaviorSubject, Observable, Subscription } from "rxjs";
import { delay, takeUntil } from 'rxjs/operators';
import { AdminService } from "../../../../admin/services/admin.service";
import { CultivosService } from "../../../services/cultivos.service";
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";

@Component({
    selector: 'app-cultivos-new-edit',
    templateUrl: './new-edit.component.html'
})
export class CultivosNewEditComponent implements OnInit, AfterViewInit, OnDestroy {
    private _finca;
    public newEditForm;
    private _filtersForm;
    private _filtersDropDown;
    public showError: boolean;
    public showApiError: boolean; // evitar mostrar la clase de error en inputs si falla el getById
    public showLengthErrorDes: boolean = false;
    public mensajes = new Array<Message>();
    public disable = false;
    public toCloseSpinner = 0;

    public provinciasList;
    public municipiosList;

    public disabledPais: Subject<boolean> = new Subject();
    public disabledProvincia: Subject<boolean> = new Subject();
    public disabledMunicipio: Subject<boolean> = new Subject();

    // Para observable personalizado (boolean value changes)
    private provinciaMunicipioCambioSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    provinciaMunicipioCambio$: Observable<boolean> = this.provinciaMunicipioCambioSubject.asObservable();
    private subscription: Subscription;

    private readonly destroy$ = new Subject<void>();


    @Input() fincaId;
    @Input() set provinciaMunicipioCambio(value: boolean) {
        this.provinciaMunicipioCambioSubject.next(value);
    };
    @Output() refresh = new EventEmitter<boolean>();
    @Output() mensaje = new EventEmitter<string>();
    @Output() refreshGeometryModal = new EventEmitter<boolean>();
    @Output() refreshProvinciaMunicipio = new EventEmitter<boolean>();


    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _spinnerService: SpinnerService,
        private readonly _adminService: AdminService,
        private readonly _dataProvider: DataProvider,
        private readonly _cultivosService: CultivosService,
        private readonly _sessionContext: SessionContextService
    ) {}

    ngOnInit() {
        this.newEditForm = this._fb.group({
            des: ['', [Validators.required, Validators.maxLength(50)]],
            pais: [{value: '', disabled: false}, Validators.required],
            provincia: [{value: '', disabled: true}],
            municipio: [{value: '', disabled: true}],
            visible_new: [{value: true, disabled: this.role !== 'Administrador'}],
            fincaDePrueba_new: [{value: false, disabled: this.role !== 'Administrador'}],
        });

        this.newEditForm.get('des').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((des) => {
            if (des) {
                this.newEditForm.get('des').errors?.maxlength ? this.showLengthErrorDes = true : this.showLengthErrorDes = false;
            } 
        });

        if (this.fincaId) {

            this.newEditForm.get('pais').clearValidators();
            this.newEditForm.get('pais').updateValueAndValidity();

            const promises: Promise<any>[] = [];
            const promisesPais: Promise<any>[] = [];

            this._spinnerService.showSpinner();
            promises.push(
                this.getFinca()
            );

            Promise.all(promises).then(
                (values) => {
                    promisesPais.push(
                        this.getProvinciasPais()
                    );

                    promisesPais.push(
                        this.getMunicipiosProvincia()
                    );

                    Promise.all(promisesPais).then(
                        () => {
                            this.newEditForm.patchValue({
                                provincia: this.provinciasList.find(x => x.id === this._finca.provinciaId) ?
                                             this.provinciasList.find(x => x.id === this._finca.provinciaId) : '',

                                municipio: this.municipiosList.find(x => x.id === this._finca.municipioId) ?
                                             this.municipiosList.find(x => x.id === this._finca.municipioId) : '',
                            });
                            this._filtersDropDown = {
                                municipio: this._finca.municipioId
                            };
                            return true;
                        }, (error) => {
                            console.log('Promise rejected with' + JSON.stringify(error));
                        }
                    ).catch(e => console.log(e));
                }, (error) => {
                    console.log('Promise rejected with ' + JSON.stringify(error));
                }
            ).catch(e => console.log(e));
        }

        this.newEditForm.get('pais').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((pais) => {
            if (pais) {
                this._filtersDropDown = {
                    paisId: pais.id
                };
                this._spinnerService.showSpinner();
                this.toCloseSpinner += 1;
                this._cultivosService.getProvinciasPais(this._filtersDropDown).toPromise().finally(() => {
                    this.checkCloseSpinner();
                }).then((resp) => {
                    if (resp.lista.length > 0) {
                        this.provinciasList = resp.lista;
                        if (this._finca) {
                            this.newEditForm.patchValue({
                                provincia: this.provinciasList.find(x => x.id === this._finca.provinciaId) ?
                                             this.provinciasList.find(x => x.id === this._finca.provinciaId) : '',
                            });
                        }
                        this.newEditForm.get('provincia').setValidators(Validators.required);
                        this.newEditForm.get('provincia').enable();
                        this.newEditForm.get('provincia').updateValueAndValidity();
                        this.disabledProvincia.next(false);
                    }
                });
            } else {
                this.provinciasList = null;
                this.municipiosList = null;
                this.disabledProvincia.next(true);
                this.disabledMunicipio.next(true);
                this.newEditForm.get('municipio').reset();
                this.newEditForm.get('provincia').reset();
            }
        });

        this.newEditForm.get('provincia').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((provincia) => {
            if (provincia) {
                this._filtersDropDown = {
                    provinciaId: provincia.id
                }
                this._spinnerService.showSpinner();
                this.toCloseSpinner += 1;
                this._cultivosService.getMunicipiosProvincia(this._filtersDropDown).toPromise().finally(() => {
                    this.checkCloseSpinner();
                }).then((resp) => {
                    if (resp.lista.length > 0) {
                        this.municipiosList = resp.lista;
                        if (this._finca) {
                            this.newEditForm.patchValue({
                                municipio: this.municipiosList.find(x => x.id === this._finca.municipioId) ?
                                             this.municipiosList.find(x => x.id === this._finca.municipioId) : '',
                            });
                        }
                        this.newEditForm.get('municipio').setValidators(Validators.required);
                        this.newEditForm.get('municipio').enable();
                        this.newEditForm.get('municipio').updateValueAndValidity();
                        this.disabledMunicipio.next(false);
                    }
                });
            } else {
                this.municipiosList = null;
                this.disabledMunicipio.next(true);
                this.newEditForm.get('municipio').reset();
            }
        });
        
        
    }

    // Evitar error "Expression has changed after it was checked"
    ngAfterViewInit(): void {
        this.subscription = this.provinciaMunicipioCambio$.pipe(
            delay(0)
        ).subscribe(value => {
            // Si se ha aceptado seguir con la modificación de la provincia/municipio a pesar de que ya tenía geometría asociada
            if (value) {
                this.continueProvinciaMunicipioCambio();
            }
        })
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        // Dejamos de suscribirnos al observable (booleano)
        this.subscription.unsubscribe();
    }

    public get campanyas() {
        return this._dataProvider.campaigns;
    }

    public get paises() {
        if (this._dataProvider.paises) {
            if (this._dataProvider.paises.length === 1 && this.newEditForm.get('pais').enabled) {
              this.newEditForm.get('pais').patchValue(this._dataProvider.paises[0]);
              this.newEditForm.get('pais').disable();
            }
          }
        return this._dataProvider.paises;
    }

    public get role() {
        return this._sessionContext.sessionUser.role;
    }

    public get isSmallScreen() {
        return this._sessionContext.isSmallScreen();
    }

    public getFinca(): Promise<any> {
        return new Promise((resolve, reject) => {
            this._spinnerService.showSpinner();
            this.toCloseSpinner += 1;
            this._cultivosService.getFinca(this.fincaId).toPromise().finally(() => {
                this.checkCloseSpinner();
            }).then((resp) => {
                this._finca = resp;
                this.newEditForm.patchValue({
                    visible_new: resp.visible,
                    fincaDePrueba_new: resp.fincaDePrueba,
                    pais: this.paises.find(x => x.id === resp.paisId),
                    des: resp.des,
                });
                setTimeout(resolve, 1);
            }, (error) => {
                this.showApiError = true;
                if (error.status === 420) {
                    this.mensajes.push({ class: 'error', message: 'global.error.noAccess' });
                } else {
                    this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
                }
            });
        });
    }

    public getProvinciasPais(): Promise<any> {
        return new Promise((resolve, reject) => {
            this._filtersDropDown = {
                paisId: this._finca.paisId
            };
            this._spinnerService.showSpinner();
            this.toCloseSpinner += 1;
            this._cultivosService.getProvinciasPais(this._filtersDropDown).toPromise().finally(() => {
                this.checkCloseSpinner();
            }).then((resp) => {
                if (resp.lista.length > 0) {
                    this.provinciasList = resp.lista;
                    this.newEditForm.get('municipio').setValidators(Validators.required);
                    this.newEditForm.get('municipio').enable();
                    this.newEditForm.get('municipio').updateValueAndValidity();
                }
                setTimeout(resolve, 1);
            });
        });
    }

    public getMunicipiosProvincia() {
        return new Promise((resolve, reject) => {
            this._filtersDropDown = {
                provinciaId: this._finca.provinciaId
            };
            this._spinnerService.showSpinner();
            this.toCloseSpinner += 1;
            this._cultivosService.getMunicipiosProvincia(this._filtersDropDown).toPromise().finally(() => {
                this.checkCloseSpinner();
            }).then((resp) => {
                if (resp.lista.length > 0) {
                    this.municipiosList = resp.lista;
                }
                setTimeout(resolve, 1);
            });
        });
    }

    public close() {
        this.refresh.emit(false);
    }

    public continueProvinciaMunicipioCambio() {
        this.refreshGeometryModal.emit(false);
        this._spinnerService.showSpinner();
        this._cultivosService.deleteCultivoParcelaByFincaId(this.fincaId).toPromise().then((resp) => {
        this._finca = {
            id: this.fincaId,
            des: this.newEditForm.get('des').value,
            visible: this.newEditForm.get('visible_new').value ? this.newEditForm.get('visible_new').value : false,
            fincaDePrueba: this.newEditForm.get('fincaDePrueba_new').value ? this.newEditForm.get('fincaDePrueba_new').value : false,
            municipioId: this.newEditForm.get('municipio').value ? this.newEditForm.get('municipio').value.id : '',
            cultivosDto: null,
        };
        return this._cultivosService.updateFinca(this._finca).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this.refresh.emit(true);
            this.mensaje.emit('global.success.itemUpdated');
        })
        }, (error) => {
            this._spinnerService.hideSpinner();
            this.refresh.emit(true);
            this.mensaje.emit('global.error.noResponse');
        })
        // Reseteamos para prevenir que se ejecute el código cuando no corresponde
        this.refreshProvinciaMunicipio.emit(false);
    }

    public save() {
        this.checkForm();
        if (this.newEditForm.valid && !this.fincaId) {
            this._finca = {
                des: this.newEditForm.get('des').value,
                visible: this.newEditForm.get('visible_new').value ? this.newEditForm.get('visible_new').value : false,
                fincaDePrueba: this.newEditForm.get('fincaDePrueba_new').value ? this.newEditForm.get('fincaDePrueba_new').value : false,
                municipioId: this.newEditForm.get('municipio').value ? this.newEditForm.get('municipio').value.id : '',
                cultivosDto: null,
            };
            this._spinnerService.showSpinner();
            this.toCloseSpinner += 1;
            this._cultivosService.createFinca(this._finca).toPromise().finally(() => {
                this.checkCloseSpinner();
            }).then((resp) => {
                if (resp.id) {
                    this.refresh.emit(true);
                    this.mensaje.emit('global.success.itemCreated');
                } else {
                    this.showError = true;
                    this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
                }
            });
        } else if (this.newEditForm.valid && this.fincaId) {
            this._finca = {
                id: this.fincaId,
                des: this.newEditForm.get('des').value,
                visible: this.newEditForm.get('visible_new').value ? this.newEditForm.get('visible_new').value : false,
                fincaDePrueba: this.newEditForm.get('fincaDePrueba_new').value ? this.newEditForm.get('fincaDePrueba_new').value : false,
                municipioId: this.newEditForm.get('municipio').value ? this.newEditForm.get('municipio').value.id : '',
                cultivosDto: null,
            };
            this._spinnerService.showSpinner();
            this.toCloseSpinner += 1;
            this._cultivosService.updateFinca(this._finca).toPromise().finally(() => {
                this.checkCloseSpinner();
            }).then(
                (resp) => {
                  this.refresh.emit(true);
                  this.mensaje.emit('global.success.itemUpdated');
                },
                (error) => {
                  this.showError = true;
                  switch (error.error.ApiErrorCode) {
                    case 6128:
                        this.mensajes.push({ class: 'error', message: 'ApiErrors.municipioNoModificable' });
                        break
                    // Geometría asociada
                    case 6190:
                        // Mostramos el modal para confirmar si se quiere continuar con la modificación de la provincia/municipio
                        this.refreshGeometryModal.emit(true);
                        break;
                    default:
                        this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
                  }
                }
            );
        }
    }

    private checkForm() {
        this.showError = this.newEditForm.invalid;

        if (this.newEditForm.get('des').errors?.maxlength) {
            this.mensajes.push({ class: 'error', message: 'mantenimientoCultivos.longitudDescripcion' });
        }
        
        if (this.newEditForm.get('des').errors?.required || this.newEditForm.get('pais').errors?.required ) {
            this.mensajes.push({ class: 'error', message: 'global.error.required' });
        }
        
    }

    private checkCloseSpinner() {
        this.toCloseSpinner -= 1;
        if (this.toCloseSpinner === 0) {
          this._spinnerService.hideSpinner();
        }
    }
}
